'use client'
import store from "@/redux/store";
import { useState, useEffect } from 'react'
import { lazy, Suspense } from "react";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'


export default function ModaBaseView({...props}) {
  const [open, setOpen] = useState(true)
  const [view, setView] = useState((<></>));


useEffect(() => {
    // Define a function that returns a Promise to fetch data
//setView( props?.current?.options?.body );
/*
props?.current?.options?.body.then((value) => {
                setView( value.default );
                });
                */
  }, []) // Empty dependency array means this effect runs once after the initial render



const closeModal = (event) => {
    if(props.closeModal) {
        props.closeModal();   
    }
    setOpen(false);
}
  
  return (
    <Dialog open={open} onClose={(event) => {closeModal(event)}} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform  rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-3xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
          
          {props?.current?.options?.body}
          {1==2 && 
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="submit"
                //onClick={() => confirmEvent(event)}
                className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
              >
                Toevoegen
              </button>
              <button
                type="button"
                data-autofocus
                onClick={(event) => closeModal(event)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Annuleer
              </button>
            </div>}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}